import { env } from '@/lib/env'

export interface ApiError extends Error {
  status: number
  details?: unknown
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

type RequestBody = unknown

interface RequestOptions {
  method?: HttpMethod
  body?: RequestBody
  token?: string | null
}

function buildUrl(path: string): string {
  const base = env.apiBaseUrl.replace(/\/+$/, '')
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${base}${normalized}`
}

async function parseJsonSafe(res: Response): Promise<unknown> {
  const text = await res.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export async function apiRequest<T>(
  path: string,
  { method = 'GET', body }: RequestOptions = {}
): Promise<T> {
  const headers: Record<string, string> = {
    Accept: 'application/json',
  }

  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData

  if (body !== undefined && !isFormData) {
    headers['Content-Type'] = 'application/json'
  }

  const res = await fetch(buildUrl(path), {
    method,
    headers,
    credentials: 'include',
    body: body !== undefined ? (isFormData ? body : JSON.stringify(body)) : undefined,
  })

  if (!res.ok) {
    const err = new Error(`API request failed with status ${res.status}`) as ApiError
    err.status = res.status
    err.details = await parseJsonSafe(res)
    throw err
  }

  return (await parseJsonSafe(res)) as T
}
